/* import __COLOCATED_TEMPLATE__ from './csv-upload.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

interface Args {
  setFile: (file: File) => void;
  file: File | null;
  fileFailedToUpload: boolean;
  parsingErrorMessage: string;
}

export default class CsvUpload extends Component<Args> {
  @service declare intl: IntlService;
  @service declare appService: $TSFixMe;

  get helperText() {
    return this.intl.t('ai-agent.playground.upload-questions-modal.short-body');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Playground::Modals::NewGroupModal::CsvUpload': typeof CsvUpload;
    'ai-agent/playground/modals/new-group-modal/csv-upload': typeof CsvUpload;
  }
}
